import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PermissionService } from '../services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private permSvc: PermissionService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const user = this.authService.getUser();

    if (!user) {
      return of(this.router.createUrlTree(['/login']));
    }

    // Role-based check
    const allowedRoles: string[] = route.data['roles'] || [];
    if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
      return of(this.router.createUrlTree(['/dashboard']));
    }

    // Permission-based check (optional, use data.permission)
    const requiredPermission: string = route.data['permission'] || '';
    if (requiredPermission && !this.permSvc.can(requiredPermission)) {
      return of(this.router.createUrlTree(['/dashboard']));
    }

    return of(true);
  }
}
